import type { Step } from "react-joyride";

export const serviceStandardTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການມາດຕະຖານບໍລິການ! ມາດຕະຖານບໍລິການ (Service Standard) ແມ່ນລະບຽບການບໍລິການທີ່ຊ່ວຍກຳນົດວິທີການບໍລິການລູກຄ້າ, ສິ່ງທີ່ຕ້ອງເຮັດ, ສິ່ງທີ່ຫ້າມເຮັດ, ຕົວຢ່າງປະໂຫຍກ, ແລະກໍລະນີພິເສດ. ທ່ານສາມາດສ້າງມາດຕະຖານບໍລິການສຳລັບຊ່ອງທາງບໍລິການຕ່າງໆ ເຊັ່ນ ຕ້ອນຮັບຫນ້າຮ້ານ, ແຊດອອນໄລນ໌, ຫຼື Live ຂາຍ. ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຫນ້ານີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="service-standard-toolbar"]',
    content:
      "ນີ້ແມ່ນປຸ່ມສ້າງມາດຕະຖານບໍລິການໃໝ່. ກົດປຸ່ມນີ້ເພື່ອເລີ່ມສ້າງມາດຕະຖານບໍລິການທີ່ທ່ານຕ້ອງການ. ມາດຕະຖານບໍລິການຈະຊ່ວຍທ່ານກຳນົດລະບຽບການບໍລິການລູກຄ້າສຳລັບຊ່ອງທາງບໍລິການຕ່າງໆ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="service-standard-filter"]',
    content:
      "ນີ້ແມ່ນພາກການກອງຂໍ້ມູນ. ທ່ານສາມາດຄົ້ນຫາມາດຕະຖານບໍລິການຕາມຊື່, ຊ່ອງທາງບໍລິການ, ພະແນກ, ຕຳແໜ່ງ, ຫຼືສະຖານະ. ກົດປຸ່ມ 'ລ້າງ' ເພື່ອລຶບການກອງທັງໝົດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="service-standard-table"]',
    content:
      "ນີ້ແມ່ນຕາຕະລາງສະແດງມາດຕະຖານບໍລິການທັງໝົດ. ທ່ານສາມາດເບິ່ງລາຍລະອຽດ, ແກ້ໄຂ, ຄັດລອກ, ເປີດ/ປິດການໃຊ້ງານ, ຫຼືລຶບມາດຕະຖານບໍລິການໄດ້ຈາກປຸ່ມການກະທໍາທີ່ຢູ່ທາງຂວາແຖວຂອງແຕ່ລະມາດຕະຖານບໍລິການ. ທ່ານຍັງສາມາດກົດເພື່ອເບິ່ງລາຍລະອຽດເພີ່ມເຕີມຂອງມາດຕະຖານບໍລິການແຕ່ລະຕົວ.",
    placement: "top",
  },
];
